import { Check, ChevronDown, Repeat } from "lucide-react";
import { useContext, useEffect, useState } from "react";
import {
	Autocomplete,
	Box,
	Button,
	Divider,
	Input,
	Stack,
	TextField,
	Typography,
} from "@mui/material";

import { AssitanceAdjustViewContext } from "../../../components/AssistanceAdjustList/AssistanceAdjustList";
import { AssistanceAdjustContext } from "../../../components/AssistanceAdjust/AssistanceAdjust";
import { getHeaders, URI_API } from "../../../utils/config";
import grain from "../../../assets/images/grain.png";
import "../AssitanceAdjustModals.scss";

export default function ReplaceNurseModal() {
	const { selectedNurses, availableAreas, nurses, isModalLoading, saveMovements, setShowModal } =
		useContext(AssitanceAdjustViewContext);

	const [actualNurse, setActualNurse] = useState<any>({});
	const [availableNurses, setAvailableNurses] = useState<any>([]);
	const { selected } = useContext(AssistanceAdjustContext);
	const [localSelectedArea, setLocalSelectedArea] = useState("");
	const [localReplacementNurse, setLocalReplacementNurse] = useState("");
	const [localSelectedReason, setLocalSelectedReason] = useState("");

	const changeReason = [
		{
			key: "Apoyo en área",
			item: "Apoyo en área",
		},
		{
			key: "Apoyo en área por demanda hospitalaria",
			item: "Apoyo en área por demanda hospitalaria",
		},
		{
			key: "Apoyo en área por complejidad de paciente",
			item: "Apoyo en área por complejidad de paciente",
		},
		{
			key: "Acuerdo personal",
			item: "Acuerdo personal",
		},
	];

	useEffect(() => {
		setActualNurse(nurses.find((e: any) => e.id === selectedNurses[0]));
	}, [nurses, selectedNurses]);

	const onReplacementNurse = (nurse_id: string) => {
		setLocalReplacementNurse(nurse_id);
		setLocalSelectedArea(
			availableNurses.find((nurse: any) => nurse.nurse_id === nurse_id)?.area_id,
		);
	};

	useEffect(() => {
		const date = selected.getFullYear() + "-" +
              String(selected.getMonth() + 1).padStart(2, "0") + "-" +
              String(selected.getDate()).padStart(2, "0");
		fetch(`${URI_API}/nursing_calendar/${date}`, getHeaders())
			.then((res) => res.json())
			.then((res) => setAvailableNurses(res));
	}, []);

	const canSave = (): boolean => {
		return localReplacementNurse !== "" && localSelectedReason !== "";
	};

	const handleSave = () => {
		saveMovements({
			replace: localReplacementNurse,
			area: localSelectedArea,
			reason: localSelectedReason,
		});
	};

	return (
		<>
			<Box sx={{ width: "100%" }}>
				<Box className="modal-header">
					<img
						className="modal-header__grain"
						src={grain}
						alt="background"
					/>
					<Box className="modal-header__title">
						<Repeat className="modal-header__title__icon" />
						<Box className="modal-header__title__text">
							<Typography className="modal-header__title__text--name">
								Reemplazar Profesional
							</Typography>
							<Typography className="modal-header__title__text--description">
								Reemplaza a un profesional en turno por otro.
							</Typography>
						</Box>
					</Box>
				</Box>
				<Box className="modal-form">
					<Stack
						flex={2}
						spacing={4}
						direction={"row"}
						divider={
							<Divider
								sx={{ top: "15.4px", position: "relative" }}
								orientation="vertical"
								flexItem
							/>
						}
					>
						<Stack
							flex={3}
							spacing={1}
							sx={{
								maxWidth: "37% !important",
								top: "5px",
								position: "relative",
							}}
						>
							<Box>
								<Typography className="modal-form__input-title--lighter">
									Profesional a reemplazar
								</Typography>
								<Typography
									className="modal-form__input-info"
									sx={{ marginTop: "0 !important" }}
								>
									{actualNurse.nursename}
								</Typography>
							</Box>
							<Box>
								<Typography className="modal-form__input-title--lighter">
									Categoría
								</Typography>
								<Typography
									className="modal-form__input-info"
									sx={{ marginTop: "0 !important" }}
								>
									{actualNurse.classx}
								</Typography>
							</Box>
							<Box>
								<Typography className="modal-form__input-title--lighter">
									Sector
								</Typography>
								<Typography
									className="modal-form__input-info"
									sx={{ marginTop: "0 !important" }}
								>
									{actualNurse.area}
								</Typography>
							</Box>
						</Stack>
						<Stack
							flex={3}
							spacing={1}
						>
							<Box>
								<Typography
									className="modal-form__input-title"
									sx={{ marginTop: "20px !important" }}
								>
									Profesional que reemplaza
								</Typography>
								<Autocomplete
									id="replaceAreaSelect"
									options={availableNurses.sort((a: any, b: any) =>
										a.nursename.localeCompare(b.nursename),
									)}
									getOptionLabel={(option: any) => option.nursename}
									onChange={(e, newValue: any) => {
										onReplacementNurse(newValue ? newValue.nurse_id : "");
									}}
									clearIcon={false}
									size="small"
									fullWidth
									popupIcon={<ChevronDown className="down-icon" />}
									renderInput={(params) => (
										<TextField
											{...params}
											placeholder="Seleccionar"
											variant="outlined"
											sx={{
												"& .MuiOutlinedInput-root": { height: "3rem" },
											}}
										/>
									)}
									value={
										availableNurses.find(
											(nurse: any) =>
												nurse.nurse_id === localReplacementNurse,
										) || null
									}
								/>
							</Box>
							<Box>
								<Typography
									className="modal-form__input-title--lighter"
									sx={{ marginTop: "10px !important" }}
								>
									Categoria
								</Typography>

								<Input
									fullWidth
									disabled
									placeholder={"-"}
									className="modal-form__disabled-input"
									disableUnderline
									sx={{
										backgroundColor: "transparent !important",
									}}
									value={
										availableNurses.find(
											(e: any) => e.nurse_id === localReplacementNurse,
										)?.classx ?? ""
									}
								></Input>
							</Box>
							<Box>
								<Typography
									className="modal-form__input-title--lighter"
									sx={{ marginTop: "0px !important" }}
								>
									Sector
								</Typography>

								<Input
									fullWidth
									disabled
									disableUnderline
									className="modal-form__disabled-input"
									placeholder="-"
									sx={{
										backgroundColor: "transparent !important",
									}}
									value={
										availableAreas.find(
											(area: any) => area.id === localSelectedArea,
										)?.area ?? ""
									}
								></Input>
							</Box>
						</Stack>
					</Stack>
					<Stack>
						<Box>
							<Typography className="modal-form__input-title">
								Razón de cambio
							</Typography>
						</Box>
						<Autocomplete
							id="selectChangeReason"
							popupIcon={<ChevronDown className="down-icon" />}
							options={changeReason.sort((a, b) => a.item.localeCompare(b.item))}
							getOptionLabel={(option) => option.item}
							onChange={(e, newValue: any) => {
								if (newValue != null) {
									setLocalSelectedReason(newValue.key);
								} else {
									setLocalSelectedReason("");
								}
							}}
							size="small"
							fullWidth
							renderInput={(params) => (
								<TextField
									{...params}
									variant="outlined"
									placeholder="Seleccionar"
									sx={{
										"& .MuiOutlinedInput-root": { height: "3rem" },
									}}
								/>
							)}
							value={
								changeReason.find((reason) => reason.key === localSelectedReason) ||
								null
							}
						/>
					</Stack>
				</Box>
				<Box
					className="buttons"
					sx={{ marginTop: "5.5vh !important" }}
				>
					<Button
						className="buttons--close"
						onClick={() => setShowModal(false)}
					>
						Cerrar
					</Button>
					<Button
						id="save-button"
						className="buttons--save"
						startIcon={<Check className="buttons--save__icon" />}
						onClick={() => handleSave()}
						disabled={!canSave() || isModalLoading}
					>
						Guardar
					</Button>
				</Box>
				{isModalLoading && (
					<Box>
						<Box className="loader-container"></Box>
						<Box className="loader-container__loader"></Box>
					</Box>
				)}
			</Box>
		</>
	);
}
